import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function parseHashParams(hash) {
  const raw = (hash || '').startsWith('#') ? (hash || '').slice(1) : (hash || '');
  const params = new URLSearchParams(raw);
  return {
    type: params.get('type'),
    accessToken: params.get('access_token'),
  };
}

/**
 * If Supabase sends the user back to the Site URL (often "/") with a recovery hash,
 * redirect them into our dedicated reset-password route while keeping the hash.
 */
const RecoveryHashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { type, accessToken } = parseHashParams(window.location?.hash);
    const isRecovery = type === 'recovery' || !!accessToken;

    if (isRecovery && location?.pathname !== '/auth/reset-password') {
      navigate(`/auth/reset-password${window.location.hash || ''}`, { replace: true });
    }
  }, [location?.pathname, navigate]);

  return null;
};

export default RecoveryHashRedirect;

